import { createSlice } from "@reduxjs/toolkit";

export const PackInitialState = {
  pack: [],
  packName: [],
  lignePack:[],
  premiumAiPack:[],
  allowedInvoice:false,
  allowedExcelReport:false,
  allowedArticleAttributes:false,
  allowedTagDLC:false
};

export const packSlice = createSlice({
  name: "pack",
  initialState: PackInitialState,
  reducers: {
    setPack: (state, action) => {
      state.pack = action.payload.pack;
    },
    setPackName: (state, action) => {
      state.packName = action.payload.packName;
    },
    setLignePack: (state, action) => {
      state.lignePack = action.payload.lignePack;
    },
    setPremiumAiPack: (state, action) => {
      state.premiumAiPack = action.payload.premiumAiPack;
    },
    setAllowedInvoice: (state, action) => {
      state.allowedInvoice = action.payload.allowedInvoice;
    },
    setAllowedExcelReport: (state, action) => {
      state.allowedExcelReport = action.payload.allowedExcelReport;
    },
    setAllowedArticleAttributes: (state, action) => {
      state.allowedArticleAttributes = action.payload.allowedArticleAttributes;
    },
    setAllowedTagDLC: (state, action) => {
      state.allowedTagDLC = action.payload.allowedTagDLC;
    },
  },
});

export const { setPack, setPackName, setLignePack,setPremiumAiPack,setAllowedInvoice,setAllowedExcelReport,setAllowedArticleAttributes,setAllowedTagDLC } =
  packSlice.actions;
